module.exports = __webpack_public_path__ + "static/media/parewa.3dd54251.gif";